// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"6fd820a0","412":"0ff2e4ca","826":"684c2715"}[chunkId] + ".css";
};